import { useContext } from 'react';

import { PieChartTooltipContext } from '../context/PieChartTooltipContext.js';

export const usePieChartTooltip = () => useContext(PieChartTooltipContext);
